import { z } from 'zod';
import { unitCodeSchema, unitChangeCheckRequestSchema } from '@xiltrion/entidad';
/** Consola › Organigrama (GUIA §3.15): crear una dependencia. El código no cambia después. */
export const unitCreateSchema = z.object({
    code: unitCodeSchema,
    name: z.string().trim().min(1).max(160),
    description: z.string().trim().max(2000).nullable().optional(),
    parentId: z.string().uuid().nullable().optional(),
    managerUserId: z.string().uuid().nullable().optional(),
});
/**
 * Cambiar una dependencia. Mover (`parentId`) pasa por la consulta de impacto de las apps; sus avisos se aceptan con
 * `acceptWarnings` (la consola los muestra antes con `POST …/units/check`).
 */
export const unitUpdateSchema = z.object({
    name: z.string().trim().min(1).max(160).optional(),
    description: z.string().trim().max(2000).nullable().optional(),
    managerUserId: z.string().uuid().nullable().optional(),
    parentId: z.string().uuid().nullable().optional(),
    sort: z.number().int().min(0).max(100_000).optional(),
    acceptWarnings: z.boolean().default(false),
});
/** Archivar o borrar (con consulta de impacto). */
export const unitGuardedSchema = z.object({ acceptWarnings: z.boolean().default(false) });
/** Reemplaza las personas de una dependencia; sacar a alguien pasa por la consulta de impacto. */
export const unitMembersSchema = z.object({ membershipIds: z.array(z.string().uuid()).max(5000), acceptWarnings: z.boolean().default(false) });
/** La consulta de impacto sola, desde la consola: con personas por membresía en vez de `sub`. */
export const unitCheckSchema = unitChangeCheckRequestSchema.omit({ subs: true }).extend({ membershipIds: z.array(z.string().uuid()).optional() });
//# sourceMappingURL=units.js.map